// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2_Cuv","label":"SetPasswdForm_label__T1PsB"};